import { isAction, type Middleware } from '@reduxjs/toolkit';
import { getLogger } from 'app-components/utils/core';

const logger = getLogger('store');

// Logs type and meta only: console output is mirrored into feedback reports, so payloads stay out.
export const actionLoggerMiddleware: Middleware = (_store) => (next) => (action) => {
  // Thunks are handled before this middleware, so only plain actions get here.
  if (isAction(action)) {
    logger.debug('action: ', action.type, 'meta' in action ? action.meta : undefined);
  }
  return next(action);
};
